<template lang="pug">
  .easyparcel
    v-layout.my-6(v-if="isFetching")
      v-row.fill-height.ma-0(align='center' justify='center')
        v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)

    .contain-layout(v-else)

      .main-layout(v-if="!action")
        v-container(style="max-width:600px").px-7
          v-layout.my-4
            v-row.fill-height.ma-0(align='center' justify='center' @click="action = null" style="cursor: pointer;")
              div.mx-auto
                v-img.mx-auto(:src="require('@/assets/images/logo_easyparcel.png')" style="width:120px" contain)

          v-btn.mt-10.button-AA-medium.white--text.info500(block outlined @click="action = 'setup-account'") {{ $t('setup_account') }}
            v-icon(v-if="settings.couriers" right color="white") mdi-check-circle-outline
          v-btn.mt-4.button-AA-medium.info500--text(style="border: 1px solid #3366FF;"
                                                    block depressed
                                                    :color="$vuetify.theme.themes[$theme].infoT08"
                                                    @click="action = 'setup-products'") {{ $t('set_products_weight') }}
            v-icon(v-if="settings.product_setup" right color="info500") mdi-check-circle-outline
          v-layout.my-4
            v-row.fill-height.ma-0(align='center' justify='center' @click="action = null" style="cursor: pointer;")
              div.mx-auto
                  div.mt-2.c1.basic600--text.text-center {{ $t('manage_your_parcel') }}
                    a.ml-1.c1.info500--text(href="https://easyparcel.com/my/en/single/my-cart/" target="_blank") {{ $t('here') }}
                  div.c1.basic600--text.text-center {{ $t('we_will_notify_you') }}

          //-v-btn.mt-4(block outlined @click="gotoActivate()") Set as default
          //-  v-icon(v-if="settings.activated" right color="green lighten-1") mdi-check-circle
      //- .action-layout(v-else)
      //- v-layout.mb-14.mt-2.mx-4(v-if="action == 'setup-account'")
      //-   div.mr-4
      //-     v-icon(left color="black" :size="20" @click="action = null") mdi-arrow-left
      //-   div.h6.mt-1 Easyparcel Setup
      setup-easy-parcel(v-if="action == 'setup-account'" @back="removeAction" :company="company")
      setup-products(v-if="action == 'setup-products'" @back="removeAction" :company="company")

</template>

<script>
import SetupEasyParcel from '@/views/admin/settings/SetupEasyParcel.vue'
import SetupProducts from '@/views/admin/settings/SetupProducts.vue'

export default {
  name: 'Easyparcel',
  components: { SetupEasyParcel, SetupProducts },
  props: ['company'],
  data: () => ({
    isFetching: true,
    settings: {
      couriers: null,
      product_setup: false,
      activated: false
    },
    action: null
  }),
  mounted () {
    this.fetchSettings()
  },
  methods: {
    gotoActivate () {
      this.$router.push('/admin/settings/shipping')
    },
    removeAction(e){
      this.action = e
    },
    fetchSettings () {
      this.$axios.get(`/shipping/settings/${this.company.slug}/easyparcel`).then((response) => {
        this.settings.couriers = response.data.couriers
      })
      .catch(() => {})
      .finally(
        this.isFetching = false
      )

      this.$axios.get(`/products/?page=1&page_size=2&company=${this.company.id}&ordering=-weight`)
        .then((response) => {
          const products = response.data.results
          products.forEach(product => {
            if (product.weight) {
              this.settings.product_setup = true
            }
          })
        }).catch(() => {})
      this.$axios.get(`/invoice_settings/?company=${this.company.id}`).then((response) => {
        if (response.data.results.length != 0) {
          const invoiceSettings = response.data.results[0]
          if (invoiceSettings.extra_settings) {
            const shippingMethod = invoiceSettings.extra_settings.shipping_method
            if (shippingMethod === 'easyparcel') {
              this.settings.activated = true
            }
          }
        }
      }).catch(() => {})
    },
  }
}
</script>

<i18n>
{
  "en": {
    "set_products_weight": "set products weight",
    "manage_your_parcel": "Manage your parcel",
    "here": "here",
    "we_will_notify_you": "We will notify you on every new order created"
  },
  "id": {
  }
}
</i18n>
